import { CharStreams, Token } from 'antlr4'

import FPlusLexer from '../lexer/ANTLR/FPlusLexer'
import FPlusParser from '../lexer/ANTLR/FPlusParser'

export function tokenize(code: string): Token[] {
  const input = CharStreams.fromString(code)
  const lexer = new FPlusLexer(input)
  // We don't need the parser for token-level decisions; collect tokens directly
  const tokens: Token[] = []
  for (let t = lexer.nextToken(); t.type !== Token.EOF; t = lexer.nextToken()) {
    tokens.push(t)
  }
  return tokens
}

export function nonWhiteSpaceTokens(tokens: Token[]): Token[] {
  return tokens.filter((t) => t.type !== FPlusParser.WS)
}
